var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9906 1.31726L26.6031 11.9523C28.7019 14.0541 30.1315 16.7325 30.7111 19.6487C31.2906 22.5648 30.9942 25.5877 29.8591 28.335C28.7241 31.0823 26.8015 33.4305 24.3346 35.0827C21.8676 36.7348 18.9671 37.6167 16 37.6167C13.0329 37.6167 10.1324 36.7348 7.66543 35.0827C5.19848 33.4305 3.2759 31.0823 2.14087 28.335C1.00585 25.5877 0.709372 22.5648 1.28895 19.6487C1.86852 16.7325 3.29811 14.0541 5.39688 11.9523L15.9906 1.31726Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.3e51b4f4778f8d82a0e2233718394e38.svg";
export { ForwardRef as ReactComponent };